import * as React from "react";
import { Box, Tooltip, Typography, useColorScheme } from "@mui/material";
import { MagnifyingGlassIcon } from "@phosphor-icons/react";

export interface AnalysingIndicatorProps {
	title?: string;
}

export function AnalysingIndicator({ title = "Analysing in progress" }: AnalysingIndicatorProps): React.JSX.Element {
	const { colorScheme } = useColorScheme();

	return (
		<Tooltip title={title} arrow>
			<Box
				sx={{
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					padding: "0 8px",
					borderRadius: "12px",
					backgroundColor: colorScheme === "dark" ? "rgba(33, 150, 243, 0.16)" : "rgba(33, 150, 243, 0.08)",
					border: `1px solid ${colorScheme === "dark" ? "rgba(33, 150, 243, 0.3)" : "rgba(33, 150, 243, 0.2)"}`,
					gap: 0.5,
				}}
			>
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						animation: "pulseMagnifyingGlass 1.5s ease-in-out infinite",
						"@keyframes pulseMagnifyingGlass": {
							"0%, 100%": { transform: "scale(1)" },
							"50%": { transform: "scale(1.15)" },
						},
					}}
				>
					<MagnifyingGlassIcon width={14} height={14} color="var(--mui-palette-info-main)" weight="duotone" />
				</Box>
				<Typography
					variant="caption"
					sx={{
						color: "info.main",
						fontSize: "0.75rem",
						fontWeight: 500,
						whiteSpace: "nowrap",
					}}
				>
					Analysing
				</Typography>
			</Box>
		</Tooltip>
	);
}
